import React, { useState } from "react";
import {
  AddFlex,
  CustomText,
  DialogHeader,
  Gap,
  PrimaryActionButton,
} from "../../reusableStyles";
import { Card } from "antd";
import Meta from "antd/es/card/Meta";
import { primaryActionColor, primaryActionColorLight } from "../../constants";
import { isNullOrUndefined } from "../../utils";
import { enqueueSnackbar } from "notistack";
import { Checkbox } from "@mui/material";
import useWindowSize from "../../Hooks/useWindowSize";

function ProductCataloguePopup({
  products,
  hideCategoryViewOption,
  setSelectedProducts,
  selectedProducts,
  onClose,
}) {
  const [selectedProductsData, setSelectedProductsData] =
    useState(selectedProducts);
  return (
    <AddFlex flexDirection="column" height="100%">
      <DialogHeader
        mainText={"Select Products"}
        subText={"Select upto 5 products"}
        padding={"10px 20px"}
        onClose={onClose}
      />
      {!hideCategoryViewOption && (
        <AddFlex gap="5px" alignItems="center" margin="10px 20px">
          <Checkbox
            checked={selectedProductsData.type === "categories"}
            onChange={(e) => {
              if (selectedProductsData.type === "categories") {
                setSelectedProductsData({ type: "products", data: [] });
              } else {
                setSelectedProductsData({ type: "categories", data: {} });
              }
            }}
            sx={{ padding: "0px" }}
          />
          <CustomText color="black">
            Display products according to categories
          </CustomText>
        </AddFlex>
      )}
      <AddFlex
        flexDirection="column"
        gap="10px"
        padding="20px"
        grow="1"
        style={{ overflow: "scroll" }}
      >
        {products.map((product) => (
          <ProductHolder
            product={product}
            setSelectedProductsData={setSelectedProductsData}
            selectedProductsData={selectedProductsData}
          />
        ))}
      </AddFlex>
      <AddFlex
        padding="10px 20px"
        justify="center"
        alignItems="center"
        style={{
          borderTop: "1px solid #ececec",
        }}
        onClick={() => {
          setSelectedProducts(selectedProductsData);
          onClose();
        }}
      >
        <PrimaryActionButton>Done</PrimaryActionButton>
      </AddFlex>
    </AddFlex>
  );
}

export default ProductCataloguePopup;

const ProductHolder = ({
  product,
  setSelectedProductsData,
  selectedProductsData,
}) => {
  const [open, setOpen] = useState(true);
  return (
    <AddFlex
      onClick={() => {
        setOpen((prev) => !prev);
      }}
      flexDirection="column"
      padding="20px"
      border="2px solid #ececec"
      //   style={{ boxShadow: "0 0 2px 2px rgba(0,0,0,0.1)" }}
      borderRadius="8px"
      gap="10px"
    >
      <AddFlex
        padding={open ? "0 0 10px 0" : "0px"}
        style={{
          borderBottom: open ? "1px solid #ececec" : "",
          cursor: "pointer",
        }}
      >
        <CustomText fontWeight="500" component="span" color="black">
          {product._id}
        </CustomText>
      </AddFlex>
      {open && (
        <AddFlex marginTop="10px" wrap="wrap" gap="10px">
          {product.products.map((item) => (
            <ProductCard
              category={product._id}
              product={item}
              setSelectedProductsData={setSelectedProductsData}
              selectedProductsData={selectedProductsData}
            />
          ))}
        </AddFlex>
      )}
    </AddFlex>
  );
};

export const ProductCard = ({
  category,
  disabled,
  product,
  setSelectedProductsData,
  selectedProductsData,
}) => {
  const { isMobileView } = useWindowSize();
  const handleChooseProduct = (selectedProduct) => {
    if (selectedProductsData.type === "products") {
      if (
        selectedProductsData.data.some(
          (product) => product.id === selectedProduct.id
        )
      ) {
        setSelectedProductsData((prev) => ({
          ...prev,
          data: prev.data.filter(
            (product) => product.id !== selectedProduct.id
          ),
        }));
      } else {
        // to restrict the addition of more that 5 products
        if (selectedProductsData.data.length >= 5) {
          enqueueSnackbar("You can choose only 5 products in this setting", {
            variant: "error",
          });
          return;
        }
        setSelectedProductsData((prev) => ({
          ...prev,
          data: [selectedProduct, ...prev.data],
        }));
      }
    } else {
      if (
        selectedProductsData.data[category]?.data?.some(
          (product) => product.id === selectedProduct.id
        )
      ) {
        setSelectedProductsData((prev) => ({
          ...prev,
          data: {
            ...prev.data,
            [category]: {
              data: prev.data[category].data.filter(
                (product) => product.id !== selectedProduct.id
              ),
            },
          },
        }));
      } else {
        // to restrict the addition of more that 5 products
        if (selectedProductsData.data[category]?.data?.length >= 5) {
          enqueueSnackbar(
            "You can choose only 5 products per category in this setting",
            {
              variant: "error",
            }
          );
          return;
        }
        setSelectedProductsData((prev) => ({
          ...prev,
          data: {
            ...prev.data,
            [category]: {
              data: prev.data[category]?.data
                ? [selectedProduct, ...prev.data[category].data]
                : [selectedProduct],
            },
          },
        }));
      }
    }
  };

  const isSelected = (selectedProduct) => {
    // this case arises when this component is used in "InstaDmAutomation" component
    if (isNullOrUndefined(selectedProductsData)) return;

    if (selectedProductsData.type === "products") {
      return selectedProductsData.data.some(
        (product) => product.id === selectedProduct.id
      );
    } else {
      return selectedProductsData.data[category]?.data?.some(
        (product) => product.id === selectedProduct.id
      );
    }
  };
  return (
    <Card
      flexDirection="column"
      gap="10px"
      border="1px solid #ececec"
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;

        handleChooseProduct(product);
      }}
      styles={{
        body: {
          padding: "8px",
          gap: "0px",
        },
      }}
      style={{
        width: isMobileView() ? "100%" : "25%",
        flexShrink: 0,
        cursor: "pointer",
        backgroundColor: isSelected(product) ? primaryActionColorLight : "",
        border: isSelected(product)
          ? `1px solid ${primaryActionColor}`
          : "1px solid #ececec",
        padding: 0,
      }}
      cover={
        <img
          src={product.imageData.mediaUrl || product.imageData.src}
          style={{
            height: "100px",
            objectFit: "cover",
            border: isSelected(product)
              ? `1px solid ${primaryActionColor}`
              : "1px solid #ececec",
            borderBottom: "none",
          }}
        />
      }
    >
      <Meta
        title={product.name}
        description={
          <CustomText lineClamp={2}>{product.description}</CustomText>
        }
        style={{ margin: 0, padding: 0, gap: 0 }}
      />
    </Card>
  );
};
